import { html, ref } from '@microsoft/fast-element';

import type { ExpandCard, SimpleCard } from './card.js';

export const expandCardTemplate = html<ExpandCard>`
	<template>
		<h3 class="heading">
			<slot name="heading"></slot>
		</h3>
		<site-image class="image">
			<slot></slot>
		</site-image>
		<div
			class="body"
			${ref('body')}
		>
			<slot name="body"></slot>
		</div>
	</template>
`;

export const simpleCardTemplate = html<SimpleCard>`
	<template>
		<site-image class="image">
			<slot></slot>
		</site-image>
		<div class="body">
			<slot name="body"></slot>
		</div>
	</template>
`;